import { render } from "./LegacyEmailContent.vue?vue&type=template&id=468ea013"
import script from "./LegacyEmailContent.vue?vue&type=script&lang=js"
export * from "./LegacyEmailContent.vue?vue&type=script&lang=js"
script.render = render

export default script